import ProfilesTab from './profiles-tab/profiles-tab'
import SettingsTab from './settings-tab/settings-tab'

export { ProfilesTab, SettingsTab }
